import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    success: null,
    delete: null,
    error: null,
    loading: false,
    silentError: false
}

const alertSlice = createSlice({
    name: "alert",
    initialState,
    reducers: {
        setLoader: (state, action) => {
            state.loading = action.payload
        },
        setSuccessAlert: (state, action) => {
            state.success = action.payload;
            state.error = null;
            state.loading = false
        },
        setDeleteAlert: (state, action) => {
            state.delete = action.payload;
            state.error = null;
            state.loading = false
            console.log(`state::`, action)
        },
        setErrorAlert: (state, action) => {
            state.success = null;
            if (typeof action.payload === 'object' && action.payload.silentError) {
                state.silentError = true;
                state.error = action.payload.message;
            } else {
                state.silentError = false;
                state.error = action.payload;
            }
            state.loading = false;
        },
        clearAlerts: (state) => {
            state.success = null;
            state.delete = null;
            state.error = null;
            state.loading = false
        },
    }
})

export const { setLoader, setSuccessAlert, setDeleteAlert, setErrorAlert, clearAlerts } = alertSlice.actions;

export default alertSlice.reducer;
